import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tt-heading",
  "use": "icon-tt-heading-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol viewBox=\"0 0 12 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tt-heading\">\n<path d=\"M11.25 13.75V0.25H8.625V5.3125H3.375V0.25H0.75V13.75H3.375V7.84375H8.625V13.75H11.25Z\" fill=\"CurrentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol